export enum RefStatus {
    Enabled = 'Activé',
    Added = 'Ajouté',
    Disabled = 'Désactivé',
    Archived = 'Archivé',
    InitialState = 'Etat initial',
    Modified = 'Modifié',
    Extended = 'Prolongé',
    Deleted = 'Supprimé',

}
export default RefStatus
